import React, { Component, type SyntheticEvent } from 'react';

import Modal from '@atlaskit/onboarding/modal';

import { type FireClickEvent } from '../../common/types/analytics';
import { buttonActionTypes } from '../../common/types/button';
import HtmlContent from '../../controllers/utils/html-content';

export type Action = {
	type: string;
	// we only support links at this time
	data?: {
		target: string;
		url: string;
	};
};

type OnClick = (e: SyntheticEvent) => void;

type Props = {
	fireClickEvent: FireClickEvent;
	body: string;
	imageSrc?: string;
	primaryAction?: Action;
	primaryText?: string;
	secondaryAction?: Action;
	secondaryText?: string;
	title?: string;
};

function header() {
	return null;
}

// eslint-disable-next-line @repo/internal/react/no-class-components
export default class ModalDialog extends Component<Props> {
	onPrimaryAction = (): void => {
		this.props.fireClickEvent('primary');
	};

	onSecondaryAction = (): void => {
		this.props.fireClickEvent('secondary');
	};

	getActionButton(
		action: Action,
		text: string,
		onClick: OnClick,
	): {
		text: string;
		onClick: (e: SyntheticEvent) => void;
	} {
		return {
			text: text,
			onClick: (e: SyntheticEvent): void => {
				if (action.type === buttonActionTypes.LINK && action.data) {
					window.open(action.data.url, action.data.target);
				}

				onClick(e);
			},
		};
	}

	getActions(): {
		text: string;
		onClick: OnClick;
	}[] {
		const { primaryAction, primaryText, secondaryAction, secondaryText } = this.props;
		const actions: Array<{ text: string; onClick: OnClick }> = [];

		if (primaryAction && primaryText) {
			actions.push(this.getActionButton(primaryAction, primaryText, this.onPrimaryAction));
		}

		if (secondaryAction && secondaryText) {
			actions.push(this.getActionButton(secondaryAction, secondaryText, this.onSecondaryAction));
		}

		return actions;
	}

	getAdditionalModalProps(): Record<string, any> {
		const props: Record<string, any> = {};
		const { imageSrc } = this.props;
		if (imageSrc) {
			props.image = imageSrc;
		} else {
			props.header = header;
		}

		return props;
	}

	render(): React.JSX.Element {
		const { title, body } = this.props;

		return (
			<Modal actions={this.getActions()} heading={title} {...this.getAdditionalModalProps()}>
				<HtmlContent html={body} />
			</Modal>
		);
	}
}
